import { render, staticRenderFns } from "./MasterDataApp.vue?vue&type=template&id=57b2afba&scoped=true"
import script from "./MasterDataApp.vue?vue&type=script&lang=js"
export * from "./MasterDataApp.vue?vue&type=script&lang=js"
import style0 from "./MasterDataApp.vue?vue&type=style&index=0&id=57b2afba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b2afba",
  null
  
)

export default component.exports